import { render } from "./NewTargetModal.vue?vue&type=template&id=62265374"
import script from "./NewTargetModal.vue?vue&type=script&lang=ts"
export * from "./NewTargetModal.vue?vue&type=script&lang=ts"

import "./NewTargetModal.vue?vue&type=style&index=0&id=62265374&lang=scss"
script.render = render

export default script